
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"7","height":"10","viewBox":"0 0 7 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 9l4-4-4-4","stroke":"#593289","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}})])
          )
        }
      }
    